








































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import router from '@/router'
import moment from 'moment'
import orderApi from '@/api/orderApi';
import CountDown from '@/components/ui/CountDown.vue'
import ShowImg from '@/components/ui/ShowImg.vue'
import showChannel from '@/components/ui/showChannel.vue'
/**
 * 正常订单状态 1
 */
@Component({
  components: {
    CountDown,
    ShowImg,
    showChannel
  },
  filters: {
    formatYMD(value: any) {
      return moment(Number(value)).format('YYYY-MM-DD HH:mm')
    },
    formatYM(value: any) {
      return moment(Number(value)).format('YYYY-MM-DD')
    }
  }
})

export default class OrderTable extends Vue {
  @Prop() public dataList: any

  private cancelOrder: boolean = false


  // 去详情
  protected goDetails(item: any) {
    router.push({ name: 'order-details', query: { orderCode: item.orderCode } })
  }

  public  goImplement(item: any) {
    router.push({ name: 'order-implement', query: { orderCode: item.orderCode } })
  }

  // 立即购买
  protected pay(item: any) {
    if (item.payStatus === 'PAY_DOING') {
      this.$message.warning('正在支付')
      return
    }
    router.push({ name: 'pay', query: { orderNo: item.orderCode } })
  }

  // 取消订单
  protected cancel(item: any) {
    if (item.payStatus === 'PAY_DOING') {
      this.$message.warning('正在支付')
      return
    }
    this.$emit('cancel', item)
  }

  // 删除订单
  protected delOrder(item: any) {
    this.$emit('delOrder', item)
  }
  protected getTime(thisTime: any) {
    if (thisTime === 0) {
      this.$emit('changeLIst', thisTime)
    }
  }

}
